import Vue from 'vue'
import api from '../api/api'
import loginVue from '../components/login'

Vue.config.productionTip = false
Vue.prototype.$http = api

console.log('login.js')

new Vue({
    render: h => h(loginVue)
}).$mount('#login-form')
